<template>
    <v-container grid-list-md class="form-home">
        <vue-final-modal
                v-model="showModal"
                classes="modal-container"
                content-class="modal-content"
        >
            <button class="modal__close" @click="showModal = false">
                <svg focusable="false" width="2em" height="2em" viewBox="0 0 24 24" data-v-05b01a5d=""><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z" fill="currentColor"></path></svg>
            </button>
            <div class="card-body px-3 py-2">
                <div class="modal__content" v-html="timelineNoticeShowModal">
                    {{ timelineNoticeShowModal }}
                </div>
                <button type="submit" class="btn btn-block bt-green py-2 btn-rounded bold mt-3 modal_okay_baby"
                    @click="showModal = false">Đã Hiểu</button>
            </div>
        </vue-final-modal>
        
        <div class="row flex-row-reverse">
            <div class='col-lg-4 col-md-4'>
                <div class='row'>
                    <div class="col-sm-12">
                        <h3 class="text-color">BÁO CÁO</h3>
                        <v-row>
                            <v-col>
                                <v-card class="deposit pa-2 white--text text-center" outlined :color="COLOR.MAIN_COLOR">
                                    <v-icon color="white" large>mdi-credit-card-plus-outline</v-icon>
                                    <br/>
                                    <span class="mt-3">SỐ DƯ</span><br/>
                                    <span class="mt-1" v-if="flag">{{ currentUser.total_coin | currency }}</span>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card class="fanpage pa-2 white--text text-center" outlined color="cyan darken-4">
                                    <v-icon color="white" large>mdi-history</v-icon>
                                    <br/>
                                    <span>NẠP THÁNG NÀY</span><br/>
                                    <span v-if="flag">{{ currentUser.coin_recharged_month | currency }}</span>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card class="fanpage pa-2 white--text text-center" outlined color="teal darken-4">
                                    <v-icon color="white" large>mdi-arrow-down-bold-circle-outline</v-icon>
                                    <br/>
                                    <span>TỔNG NẠP</span><br/>
                                    <span v-if="flag">{{ currentUser.coin_recharged | currency }}</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <div class='col-sm-12 date_select'>
                        <div class="row">
                            <div class='col-sm-12 fromDate'>
                                <label class="control-label text-color">Từ ngày</label>
                                <date-picker
                                        v-if="loaded"
                                        v-model="fromDate"
                                        lang="en"
                                        format="YYYY-MM-DD"
                                        type="date"
                                        value-type="format"
                                ></date-picker>
                            </div>
                            <div class='col-sm-12 endDate'>
                                <label class="control-label text-color">Đến ngày</label>
                                <date-picker
                                        v-if="loaded"
                                        v-model="endDate"
                                        lang="en"
                                        format="YYYY-MM-DD"
                                        type="date"
                                        value-type="format"
                                ></date-picker>
                            </div>
                            <div class='col-sm-12'>
                                <v-btn :color="COLOR.MAIN_COLOR" class="white--text ml-3 btn-xem"
                                       @click.prevent="doFilter">
                                    Xem
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class='col-sm-12'>
                        <highcharts v-if="loaded" :options="chartOptions"></highcharts>
                    </div>
                </div>
            </div>

            <div class='col-lg-8 col-md-8'>
                <div class="timelineNotice"
                     v-for="timelineNotice in timelineNotices"
                     v-bind:key="timelineNotice.id"
                     v-html="timelineNotice.notice_show"
                >
                    <p>{{ timelineNotice.notice_show }}</p>
                </div>
                <div class="loading_area">
                    <ul class="flex-container">
                        <li>
                            <span class="load5"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
  import Vue from 'vue'
  import Highcharts from 'highcharts'
  import HighchartsVue from 'highcharts-vue'
  import moment from 'moment'
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css';
  import {COLOR} from "~/config/constant";
  import {AUTH_GET_HISTORY_COIN, AUTH_USER} from "~/store/actions.type";
  import {MENU_SEEDING} from "~/config/navbar";
  import $ from 'jquery';
  import VueYoutube from 'vue-youtube'
  // import AuthService from "~/common/service.api";
  // import Swal from 'sweetalert2';
  // import {getErrorMsg} from "~/common/helper.string";
  import {TIMELINE_NOTICE} from "~/store/actions.type";
  import VueFinalModal from 'vue-final-modal';
  
  Vue.use(VueYoutube);
  Vue.use(HighchartsVue, {
    highcharts: Highcharts
  });
  Vue.use(VueFinalModal);

  export default {
    components: {
      DatePicker
    },
    data() {
      return {
        // Color chinh
        COLOR: COLOR,
        loaded: false,
        videoId: 'V7smeN8hAOw',
        videoStatus: true,
        chartOptions: {
          chart: {
            zoomType: 'xy'
          },
          credits: {
            enabled: false
          },
          title: {
            text: ''
          },
          xAxis: [
            {
              categories: [], // get from API
              // crosshair: true
            }
          ],
          yAxis: [{
            title: {
              text: '',
              style: {
                color: Highcharts.getOptions().colors[1]
              }
            },
            labels: {
              format: '',
              style: {
                color: Highcharts.getOptions().colors[1]
              }
            },
            opposite: true
          },
            {
              labels: {
                format: '',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              title: {
                text: 'Số Tiền VND',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              }
            }],
          tooltip: {
            shared: true
          },
          legend: {
            layout: 'vertical',
            align: 'left',
            x: 100,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor:
              Highcharts.defaultOptions.legend.backgroundColor || // theme
              'rgba(255,255,255,0.25)'
          },
          series: [{
            name: 'Tiền Chi',
            type: 'column',
            color: '#FFA000',
            yAxis: 1,
            data: null, // get from API
            tooltip: {
              valueSuffix: ''
            }
          }, {
            name: 'Tiền Nạp',
            type: 'column',
            color: '#004D40',
            yAxis: 1,
            data: null, // get from API
            tooltip: {
              valueSuffix: ''
            }
          }]
        },
        fromDate: moment().subtract(30, 'd').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        pageSize: 10,
        currentUser: {},
        flag: false,
        menu_seeding: [],
        visible: 0, 
          timelineNotices: [],
          offset: 6,
          offsetStart: 6,
          showModal: false,
          timelineNoticeShowModal: '',
          offsetLoaded: [],
      }
    },
    created() {
      this.menu_seeding = MENU_SEEDING;
    },
    computed: {
      player() {
        return this.$refs.youtube.player
      }
    },
    mounted() {
      this.doFilter();
      this.initDefault();
        this.getInitialTimelineNotices();

        if (window.innerWidth <= 1263) {
        setTimeout(function () {
          $(".v-overlay").css('z-index', 'unset');
        }, 0);
      }
    },
    methods: {
        async getInitialTimelineNotices () {
            $(".loading_area").css('display', 'none');
            
            for (let i = 0; i < this.offsetStart; i++) {
                
                await this.$store.dispatch(TIMELINE_NOTICE, {offset: i}).then(data => {
                    
                    if (data.data[0] != undefined) {
                        
                        this.offsetLoaded.push(i);
                        
                        if (i == 0) {
                            // this.showModal = true;//test show popup
                            this.timelineNoticeShowModal = data.data[0].notice;
                        }

                        this.timelineNotices.push({
                            'id': data.data[0].id,
                            'notice_show': '<div class="card mb-3" style="margin-bottom: 1rem !important;">\n' +
'                    <div class="card-header bg-light">\n' +
'                        <div class="row justify-content-between">\n' +
'                            <div class="col" style="padding-top: 0px; padding-bottom: 0px;">\n' +
'                                <div class="d-flex">\n' +
'                                    <div class="avatar avatar-2xl">\n' +
'                                        <img class="rounded-circle" src="/images/admin.jpg" alt="">\n' +
'\n' +
'                                    </div>\n' +
'                                    <div class="flex-1 align-self-center ml-2">\n' +
'                                        <p class="mb-1 lh-1"><a class="font-weight-semi-bold" href="#" style="pointer-events: none;">Quản Trị Viên</a></p>\n' +
'                                        <p class="mb-0 fs--1">' + data.data[0].created_at + '<svg class="svg-inline--fa fa-globe-americas fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="globe-americas" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" data-fa-i2svg=""><path fill="currentColor" d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"></path></svg><!-- <span class="fas fa-globe-americas"></span> --></p>\n' +
'                                    </div>\n' +
'                                </div>\n' +
'                            </div>\n' +
'                        </div>\n' +
'                    </div>\n' +
'                    <div class="card-body">\n' +
'                        ' + data.data[0].notice +
'                    </div>\n' +
'                </div>'
                        });
                    }
                });
            }

            if (this.offsetLoaded.length === this.offsetStart) {
                this.scroll(this.timelineNotices);
            }
        },

        scroll (timelineNotices) {
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

                if (bottomOfWindow) {

                    this.$store.dispatch(TIMELINE_NOTICE, {offset: this.offset}).then(data => {
                        this.offset = data.offset + 1;
                        
                        if (data.data[0] != undefined) {
                            
                            this.offsetLoaded.push(data.offset);
                            
                            const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
                            var countOffset = countOccurrences(this.offsetLoaded, data.offset);
                            
                            if (countOffset === 1) {

                                $(".loading_area").css('display', 'block');

                                setTimeout(function () {
                                    timelineNotices.push({
                                        'id': data.data[0].id,
                                        'notice_show': '<div class="card mb-3" style="margin-bottom: 1rem !important;">\n' +
'                    <div class="card-header bg-light">\n' +
'                        <div class="row justify-content-between">\n' +
'                            <div class="col" style="padding-top: 0px; padding-bottom: 0px;">\n' +
'                                <div class="d-flex">\n' +
'                                    <div class="avatar avatar-2xl">\n' +
'                                        <img class="rounded-circle" src="/images/admin.jpg" alt="">\n' +
'\n' +
'                                    </div>\n' +
'                                    <div class="flex-1 align-self-center ml-2">\n' +
'                                        <p class="mb-1 lh-1"><a class="font-weight-semi-bold" href="#" style="pointer-events: none;">Quản Trị Viên</a></p>\n' +
'                                        <p class="mb-0 fs--1">' + data.data[0].created_at + '<svg class="svg-inline--fa fa-globe-americas fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="globe-americas" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" data-fa-i2svg=""><path fill="currentColor" d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"></path></svg><!-- <span class="fas fa-globe-americas"></span> --></p>\n' +
'                                    </div>\n' +
'                                </div>\n' +
'                            </div>\n' +
'                        </div>\n' +
'                    </div>\n' +
'                    <div class="card-body">\n' +
'                        ' + data.data[0].notice +
'                    </div>\n' +
'                </div>'
                                    });
                                    $(".loading_area").css('display', 'none');
                                }, 1500);
                            }
                        }
                    });
                }
            };
        },
        
        async initDefault() {
            let currentUser = await this.$store.dispatch(AUTH_USER);

            if (currentUser) {

                // var name = currentUser.data.name !== null ? currentUser.data.name : '';
                // var email = currentUser.data.email !== null ? currentUser.data.email : '';
                //
                // var showPopupUpdate = localStorage.getItem('showPopupUpdate');
                var showPopupTimelineNotice = localStorage.getItem('showPopupTimelineNotice');

                if (showPopupTimelineNotice == 1) {
                    this.showModal = true;
                    localStorage.setItem('showPopupTimelineNotice', 0);
                }
                
                // if (showPopupUpdate == 1) {
                //
                //     Swal.fire({
                //         title: 'Cập nhật số điện thoại để nhận được những ưu đãi và support tốt nhất:',
                //         html: '<input id="name" class="swal2-input" required type="hidden" value="'+name+'">'
                //             + '<input id="email" class="swal2-input" required type="hidden" value="'+email+'">'
                //             + '<input id="mobile" class="swal2-input" required type="text" placeholder="Số điện thoại">'
                //         ,
                //         icon: 'info',
                //         showCancelButton: true,
                //         confirmButtonColor: '#3085d6',
                //         cancelButtonColor: '#d33',
                //         confirmButtonText: 'Cập nhật ngay',
                //         cancelButtonText: 'Để sau',
                //         preConfirm: () => {
                //             return new Promise(function () {
                //
                //                 var name_val = $('#name').val();
                //                 var email_val = $('#email').val();
                //                 var mobile_val = $('#mobile').val();
                //
                //                 if (mobile_val == '') {
                //                     Swal.showValidationMessage("Vui lòng nhập Số điện thoại");
                //                     Swal.enableButtons();
                //                 }
                //                 if (mobile_val !== '') {
                //                     let params = {
                //                         name: name_val !== '' ? name_val : '',
                //                         email: email_val !== '' ? email_val : '',
                //                         mobile: mobile_val
                //                     };
                //                     Swal.showLoading();
                //
                //                     AuthService.post("change-information", params)
                //                         .then(resp => {
                //                             if( resp.data.success) {
                //                                 Swal.fire({
                //                                     title: 'Cập nhật thông tin thành công!'
                //                                 });
                //                             } else {
                //                                 Swal.hideLoading();
                //                                 Swal.showValidationMessage(resp.data.message);
                //                                 Swal.enableButtons();
                //                             }
                //                         })
                //                         .catch(err => {
                //                             Swal.hideLoading();
                //                             Swal.showValidationMessage(getErrorMsg(err));
                //                             Swal.enableButtons();
                //                         });
                //                 }
                //             });
                //         }
                //     }).then((result) => {
                //         if (result.value) {
                //             Swal.fire({
                //                 title: 'Cập nhật thông tin thành công'
                //             })
                //         }
                //     });
                //
                //     localStorage.setItem('showPopupUpdate', 0);
                // }
                this.currentUser = currentUser.data;
                this.flag = true;
            }
        },

      async doFilter() {
        this.loaded = false;
        let res = await this.$store.dispatch(AUTH_GET_HISTORY_COIN, {
          start_date: this.fromDate,
          end_date: this.endDate
        });
        if (res) {
          this.chartOptions.xAxis[0].categories = res.dates;
          this.chartOptions.series[0].data = res.expenses;
          this.chartOptions.series[1].data = res.recharged;
          this.loaded = true;
        }
      },
      playVideo() {
        if (this.videoStatus === true) {
          this.videoStatus = false;
          this.player.playVideo();
        } else {
          this.videoStatus = true;
          this.player.pauseVideo();
        }
      },
      playing() {
        this.videoStatus = false;
      },
      paused() {
        this.videoStatus = true;
      },
      youtube_parser(url) {
        let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        let match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
      }
    },
  };
</script>
<style lang="scss">
    @import "../../scss/main";

    .card {
        -webkit-box-shadow: 0 7px 14px 0 rgba(65, 69, 88, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
        box-shadow: 0 7px 14px 0 rgba(65, 69, 88, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
        margin-bottom: 1rem !important;

        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 0px solid #edf2f9;
        border-radius: 0.375rem;
    }

    .card-header:first-child {
        border-radius: calc(0.375rem - 0px) calc(0.375rem - 0px) 0 0;
    }

    .bg-light {
        background-color: #f9fafd !important;
    }
    .card-header {
        padding: 1rem 1.25rem;
        margin-bottom: 0;
        background-color: #fff;
        border-bottom: 0px solid #edf2f9;
    }

    .justify-content-between {
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
    .avatar-2xl {
        height: 2.5rem;
        width: 2.5rem;
    }
    .avatar {
        position: relative;
        display: inline-block;
    }
    .avatar img, 
    .avatar .avatar-name {
        width: 100%;
        height: 100%;
    }
    .rounded-circle {
        border-radius: 50% !important;
    }
    .lh-1 {
        line-height: 1 !important;
    }
    .mb-1 {
        margin-bottom: 0.25rem !important;
    }
    .fs--1 {
        font-size: 0.83333rem !important;
    }
    .mb-0 {
        margin-bottom: 0 !important;
    }
    .font-weight-semi-bold {
        font-weight: 600 !important;
    }
    a {
        color: #2c7be5;
        text-decoration: none;
    }
    p {
        margin-top: 0;
        margin-bottom: 1rem;
    }
    .svg-inline--fa.fa-w-16 {
        width: 1em;
    }
    .svg-inline--fa {
        display: inline-block;
        font-size: inherit;
        height: 1em;
        overflow: visible;
        vertical-align: -.125em;
    }

    .card-body:last-child {
        border-bottom-left-radius: 0.375rem;
        border-bottom-right-radius: 0.375rem;
    }
    .card-body {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        padding: 1.25rem 1.25rem;
    }
    p {
        margin-top: 0;
        margin-bottom: 1rem;
    }
    @media only screen and (max-width: 1903px) {
        .btn-xem {
            margin-top: 24px;
        }
    }

    @media only screen and (max-width: 767px) {
        div.mx-datepicker {
            float: right;
        }
        audio, canvas, embed, iframe, img, object, svg, video {
            width: auto;
        }
    }

    .text-color {
        color: $mainColor;
        font-weight: bold;
    }

    .btn-reload {
        float: right;
        margin-right: 60px;
    }

    .v-card.bg-gradient {
        background: linear-gradient(51.19deg, #4267b2 9.02%, #0084F8 90.81%);
    }

    .v-card.notice {
        background: linear-gradient(69.69deg, #FF8576 9.02%, #FF3B30 90.81%);
    }

    .fbsuff {
        height: 130px;
    }

    .a-suport {
        text-decoration: none;
        color: white !important;
    }

    .a-suport:hover {
        color: $clickMenuColor !important;
    }

    .goto-link {
        text-decoration: unset;
        color: unset;
    }

    .swal2-container .swal2-popup{
        font-family: Arial !important;
    }
    .swal2-container .swal2-popup .swal2-header .swal2-title{
        font-size: 21px;
        margin-bottom: 20px;
    }
    .swal2-container .swal2-popup .swal2-content #swal2-content span{
        font-size: 18px;
        line-height: 25px;
    }
    .swal2-container .swal2-popup .swal2-content #swal2-content span b{
        font-size: 20px;
    }
    .swal2-container .swal2-input {
        max-width: 100% !important;
        width: 100% !important;
        margin-top: 0px !important;
    }


    .flex-container {
        list-style: none;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;

        li {
            padding: 10px;
            height: 100px;
            width: 100px;
            margin: 30px 20px;
            position: relative;
            text-align: center;
        }
    }

    .load5 {
        display: inline-block;
        position: relative;
        width: 5px;
        height: 50px;
        border-radius: 1000px;
        background: rgb(66, 103, 178);
        margin-top: 5px;
        animation: upDown2 1s ease infinite;
        animation-direction: alternate;
        animation-delay: .25s;

        &:after, &:before {
            @extend .load5;
            position: absolute;
            content: '';
            animation: upDown 1s ease infinite;
            animation-direction: alternate;
        }

        &:before {
            left: -10px;
        }

        &:after {
            left: 10px;
            animation-delay: .5s;
        }
    }

    @keyframes upDown {
        from {
            transform: translateY(20px);
        }
        to {
            transform: translateY(-20px);
        }
    }

    @keyframes upDown2 {
        from {
            transform: translateY(30px);
        }
        to {
            transform: translateY(-20px);
        }
    }
    .flex-row-reverse {
        flex-direction: row-reverse!important;
    }
    
    div.date_select div.fromDate,
    div.date_select div.endDate {
        display: inline-flex;
    }

    div.date_select div.fromDate .text-color,
    div.date_select div.endDate .text-color {
        width: 75px;
    }
    .modal__content {
        word-break: break-word;
        margin-top: 2em;
        margin-bottom: 1.25em;
    }
    .card-body img,
    .modal__content img {
        max-width: 100%;
    }
</style>

<style scoped>
    ::v-deep .modal-container {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-x: hidden;
        overflow-y: auto;
        margin: 10px;
    }
    ::v-deep .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 1rem;
        border: 1px solid #e2e8f0;
        background: #fff;
        max-width: 500px;
        border-radius: 20px;
        width: 100%;
        margin: auto;
    }

    @media only screen and (min-width: 767px) {
        ::v-deep .modal-content {
            max-width: 500px;
        }
    }
    
    
    .dark-mode div::v-deep .modal-content {
        border-color: #2d3748;
        background-color: #1a202c;
    }
    .modal__title {
        margin: 0 2rem 0 0;
        font-size: 1.5rem;
        font-weight: 700;
    }
    
    .modal__close {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }
    .modal_okay_baby {
        background-color: #1fab89;
        color: #fff;
        width: 100%;
        position: initial;
        border-radius: 5px;
    }
</style>
